<template>
  <div class="language-switcher">
    <button
      @click="toggleLanguage"
      class="lang-btn"
      :title="currentLocale === 'en' ? 'Switch to Chinese' : '切换到英文'"
    >
      <span class="lang-text">{{ currentLocale === 'zh' ? 'EN' : 'ZH' }}</span>
    </button>
  </div>
</template>

<script>
import { useLocaleStore } from '@/stores'
import { storeToRefs } from 'pinia'

export default {
  setup() {
    const localeStore = useLocaleStore()
    const { currentLocale } = storeToRefs(localeStore)

    const toggleLanguage = () => {
      const newLocale = currentLocale.value === 'en' ? 'zh' : 'en'
      localeStore.setLocale(newLocale)
    }

    return {
      currentLocale,
      toggleLanguage
    }
  }
}
</script>

<style scoped>
.language-switcher {
  display: flex;
  align-items: center;
}

.lang-btn {
  padding: var(--space-2) var(--space-3);
  background-color: var(--color-pure-black);
  border: 1px solid var(--border-mist-10);
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all var(--transition-base);
}

.lang-btn:hover {
  border-color: var(--color-cyan);
  background-color: rgba(0, 255, 255, 0.05);
}

.lang-text {
  font-size: 0.8125rem;
  font-weight: 500;
  color: var(--color-ghost-white);
  letter-spacing: 0.02em;
}

.lang-btn:hover .lang-text {
  color: var(--color-cyan);
}

@media (max-width: 768px) {
  .lang-btn {
    padding: var(--space-1) var(--space-2);
  }

  .lang-text {
    font-size: 0.75rem;
  }
}
</style>
